import { getDefaultQuestionAndAnswerSetIDs } from "../pages/helpers";

export const isAllIdsExistsInSecondObject = (
  questionsAndanswers: QuestionAndAnswerId[],
  localQuestionsAndAnswers: QuestionAndAnswerId[]
) => {
  if (!questionsAndanswers || !localQuestionsAndAnswers) {
    return false;
  }
  for (const [key] of Object.entries(questionsAndanswers)) {
    const questionId: number = Number(key);
    if (!questionId || !localQuestionsAndAnswers[questionId]) {
      return false;
    }
  }
  return true;
};

export const isAllIdsExists = (
  questionsAndanswers: QuestionAndAnswerId[],
  localQuestionsAndAnswers: QuestionAndAnswerId[]
) => {
  const answer =
    isAllIdsExistsInSecondObject(
      questionsAndanswers,
      localQuestionsAndAnswers
    ) &&
    isAllIdsExistsInSecondObject(localQuestionsAndAnswers, questionsAndanswers);
  return answer;
};

export const formatQuestionsAndAnswers = (
  questionsAndAnswers: QuestionGroup[]
) => {
  let formatQuestions = {};
  questionsAndAnswers?.forEach((QuestionGroup: QuestionGroup) => {
    if (QuestionGroup.questions)
      return QuestionGroup.questions.map((question: Question) => {
        if (question.id && question.selectedAnswer)
          formatQuestions = {
            ...formatQuestions,
            [question.id]: question.selectedAnswer
          };
        return question;
      });
  });
  return formatQuestions;
};

export const formatQuestionsAndAllowedAnswers = (
  questionsAndAnswers: QuestionGroup[]
) => {
  const questionsWithAllowedAnswers: QuestionsWithAllowedAnswers = {};

  const questions = questionsAndAnswers.flatMap((x) => x.questions);

  questions.map(
    ({ id, answers }) =>
      (questionsWithAllowedAnswers[id] = answers.flatMap((a) => a.id))
  );

  return questionsWithAllowedAnswers;
};

export const localQuestionsMatchCurrentSetOptions = (
  questionsAndanswers: QuestionGroup[],
  localQuestionsAndAnswers: QuestionIdAndAnswerId[]
) => {
  if (!questionsAndanswers || !localQuestionsAndAnswers) {
    return false;
  }

  // response question data
  const acceptedQuestionsAndAnswers: QuestionsWithAllowedAnswers[] =
    Object.entries(formatQuestionsAndAllowedAnswers(questionsAndanswers));
  const acceptedQuestionIds = acceptedQuestionsAndAnswers.map((qAnda) =>
    Number(qAnda[0])
  );
  const defaultQuestionsAndAnswers =
    getDefaultQuestionAndAnswerSetIDs(questionsAndanswers);

  let match = true;

  // question set lengths do not match
  if (
    acceptedQuestionsAndAnswers.length !==
    Object.keys(localQuestionsAndAnswers).length
  ) {
    return false;
  }

  // check response qAnda vs local
  acceptedQuestionsAndAnswers.forEach((qAnda) => {
    const questionId = Number(qAnda[0]);
    const answerIds: Array<Number> = qAnda[1];

    // response question id doesn't match or exist locally
    if (!questionId || !localQuestionsAndAnswers[questionId]) {
      match = false;
      return;
    }

    // response answer doesn't match or exist for question locally
    if (!answerIds.includes(Number(localQuestionsAndAnswers[questionId]))) {
      match = false;
      return;
    }
  });

  // check local qAnda vs response
  Object.keys(localQuestionsAndAnswers).forEach((localQuestionsAndAnswer) => {
    const localQuestionID = Number(localQuestionsAndAnswer);
    // set local answers value as array to future proof for multi choice changes
    const localAnswersToCompare: any = Array.isArray(
      localQuestionsAndAnswers[localQuestionID]
    )
      ? localQuestionsAndAnswers[localQuestionID]
      : [localQuestionsAndAnswers[localQuestionID]];

    // local question id does not match any response question
    if (!acceptedQuestionIds.includes(localQuestionID)) {
      match = false;
      return;
    }
    localAnswersToCompare.forEach((localAnswer: number) => {
      // local answer does not match any response answers
      if (!defaultQuestionsAndAnswers[localQuestionID].includes(localAnswer)) {
        match = false;
        return;
      }
    });
  });
  return match;
};

export const getAnswerFromQuestionById = (question: Question, answerId: number[]) => {
  if (!answerId || !question) {
    return null;
  }
  return question.answers.find((answer) => answer.id === answerId[0]);
};
